import { useMemo, useState } from "react";
import { FashCreativesController } from "../../../../controllers";
import constant from "../../../../utils/constant";
import moment from "moment";

const useFashThemes = () => {
  const [addThemeModal, setAddThemeModal] = useState(false);

  const openAddThemeModal = () => {
    setAddThemeModal(true);
  };

  const closeModal = () => {
    setAddThemeModal(false);
  };

  const { isLoading, data, isFetching } =
    FashCreativesController.useGetThemes();

  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const subscriptionDate = cell.row.original?.createdAt;
        return (
          <span>{moment(subscriptionDate).format("DD/MM/YYYY HH:mm a")}</span>
        );
      },
    },
    {
      Header: "Theme Name",
      accessor: "name",
    },
    {
      Header: "Description",
      accessor: "description",
    },
  ];

  return {
    openAddThemeModal,
    closeModal,
    addThemeModal,
    tableData,
    isLoading,
    isFetching,
    tableColumns,
  };
};

export default useFashThemes;
